export default class Helper {
    static toNumber(object: any, valueDefault: number | null | undefined = null): number | null | undefined {
        if (!object)
            return valueDefault;
        else {
            try {
                return Number(object.toString());
            } catch (error) {
                return valueDefault;
            }
        }
    }

    static toBool(object: any, valueDefault: boolean | null | undefined = false): boolean | null | undefined {
        if (!object)
            return valueDefault;
        else {
            try {
                const str = object.toString().toLowerCase();
                return (str !== '0' && str !== 'false') || str === 'true';
            } catch (error) {
                return valueDefault;
            }
        }
    }
}